export default "__VITE_ASSET__CnLTIF69__"